import { QueryKeyParam, createQueryKey } from '../../query';

const activationKeys = () =>
  createQueryKey({
    all: ['offers', 'activations'] as const,
    id: (activationId: QueryKeyParam) =>
      createQueryKey({
        all: ['offers', 'activations', activationId] as const,
        detail: ['offers', 'activations', activationId, 'detail'] as const,
      }),
  });

export { activationKeys };
